module.exports = __webpack_public_path__ + "static/media/JeffVet_logo_lockup_1.b9d920a2.svg";